import {request} from '../jslib/request'
import axios from 'axios'
const BASE_REQUEST = '/tms/invoice'
const BASE_REQUEST_REFUND = '/tms/invoiceRefundRecord'

export function getList(data) {
  return request({
    url: `${BASE_REQUEST}/page`,
    method: 'get',
    data
  })
}
export function updateStatus(data) {
  return request({
    url: `${BASE_REQUEST}/updateStatus`,
    method: 'post',
    data
  })
}
export function invoiceCostRel(data) {
  return request({
    url: `${BASE_REQUEST}/invoiceCostRel`,
    method: 'post',
    data,
    json: true
  })
}
export function aiMatcher(data) {
  return request({
    url: `${BASE_REQUEST}/aiMatcher`,
    method: 'post',
    data
  })
}
export function delInvoice(id) {
  return request({
    url: `${BASE_REQUEST}/del/${id}`,
    method: 'post'
  })
}
export function delInvoiceCost(id) {
  return request({
    url: `${BASE_REQUEST}/delInvoiceCost/${id}`,
    method: 'post'
  })
}
export function delInvoiceShipName(id) {
  return request({
    url: `${BASE_REQUEST}/delInvoiceShipName/${id}`,
    method: 'post'
  })
}

export function submitInvoiceRefund(data) {
  return request({
    url: `${BASE_REQUEST_REFUND}/submitInvoiceRefund`,
    method: 'post',
    data,
    json: true
  })
}
export function getInvoiceRefundRecordByProcessId(processId) {
  return request({
    url: `${BASE_REQUEST_REFUND}/getInvoiceRefundRecordByProcessId`,
    method: 'get',
    data:{processId}
  })
}

